export class AuthError extends Error {
  constructor(
    message: string,
    public code?: string,
    public originalError?: unknown
  ) {
    super(message);
    this.name = 'AuthError';
  }
}

export const handleAuthError = (error: unknown): AuthError => {
  if (error instanceof AuthError) {
    return error;
  }

  const firebaseError = error as { code?: string; message: string };
  
  if (firebaseError.code === 'auth/popup-blocked') {
    return new AuthError(
      'Authentication popup was blocked by your browser. Please allow popups for this site.',
      firebaseError.code,
      error
    );
  }

  if (error instanceof Error) {
    return new AuthError(error.message, 'unknown-error', error);
  }

  return new AuthError('An unknown error occurred', 'unknown-error', error);
};